module.exports = __webpack_public_path__ + "img/second-top.19ff66d2.png";